import { Col, Row } from 'antd';
import React, { useContext } from 'react';
import Panel from '../../../../../shared/components/card/Panel';
import { FormTextInput } from '../../../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE } from '../../../../../shared/constants/commonConstants';
import { AdmissionContext } from '../../../../crm/inPatient/newAdmission/AdmissionContext';
import ReconcilationClaimDetailHeader from './ReconciliationClaimDetailHeader';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { Payer } from '../../../../../shared/models/payer.model';

const PatientDetail = ({ form }: any ): any => {

  const admissionContext = useContext(AdmissionContext);
  const { claimDetailBackup } = admissionContext;
  const commonDetail = { form, claimDetailBackup };
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const payerName = configuredPayers.find((payer: any): any => {
    return payer.id === form.getFieldValue('payerId');
  })?.name;
  form.setFieldsValue({'payerName' : payerName});
  return <Panel className="member-scroll" data-testid="member-detail-card">
    <ReconcilationClaimDetailHeader />
    <Row gutter={GUTTOR_SPACE}>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'patientName',
        }} />
        </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'hospitalName',
          label: 'Hospital Name',
        }} />    </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'policyNumber',
          label: 'Policy Number',
        }} />    </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'policyHolder',
          label: 'Policy Holder',
        }} />    </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'inPatientNumber',
          label: 'Inpatient Number',
        }} />    </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'insurerName',
          label: 'Insurer Name',
        }} />    </Col>
      <Col md={12}>
        <FormTextInput detail={{
          ...commonDetail,
          key: 'payerName',
          label: 'Payer Name',
        }} />    </Col>
    </Row>
  </Panel>;

};
export default PatientDetail;
